import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "合集导航", to: "/collections" },
  { label: "一周盘点", to: "/weekly" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/90 backdrop-blur-md">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4 md:h-[72px]">
          <Link to="/" className="flex shrink-0 items-center gap-2.5" onClick={() => setOpen(false)}>
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-water-flash-fill text-xl leading-none" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
                吃瓜合集导航
              </span>
              <span className="mt-0.5 hidden text-[11px] tracking-[0.18em] text-foreground-500 sm:block">
                一站式吃完全部瓜
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/collections"
              className="hidden items-center gap-1.5 rounded-md bg-foreground-950 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 md:flex"
            >
              <i className="ri-search-line text-base leading-none" aria-hidden="true"></i>
              <span className="whitespace-nowrap">找合集</span>
            </Link>

            <button
              type="button"
              aria-label="打开菜单"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
            >
              <i className={open ? "ri-close-line text-2xl leading-none" : "ri-menu-line text-2xl leading-none"} aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <nav className="flex flex-col px-4 py-3" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-base font-medium transition-colors ${
                    isActive ? "bg-primary-100 text-primary-700" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg leading-none" aria-hidden="true"></i>
              </NavLink>
            ))}
            {location.pathname !== "/collections" && (
              <Link
                to="/collections"
                onClick={() => setOpen(false)}
                className="mt-2 flex items-center justify-center gap-1.5 rounded-md bg-foreground-950 px-3 py-3 text-base font-medium text-background-50"
              >
                <i className="ri-search-line leading-none" aria-hidden="true"></i>
                <span>去合集导航找瓜</span>
              </Link>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}